let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6qYbg")).then(() => parcelRequire('4LSMP'));